import React, { useEffect } from 'react';
import ReactGA from 'react-ga4';
import CompanyAddressesForm from '../../../components/Enrollment/CompanyAddresses/CompanyAddressesForm';
import { CompanyAddressesFormData } from '../../../components/Enrollment/CompanyAddresses/CompanyAddressesFormData';
import FormVariant from '../../../components/Enrollment/FormVariant';
import { useEnrollment } from '../../../context/Enrollment/EnrollmentContext';
import { EnrollmentData } from '../EnrollmentData';
import { removeEmptyStrings } from '../../../utils/util';

const CompanyAddresses = (): JSX.Element => {
  const { enrollmentData, setEnrollmentData, nextPage } = useEnrollment();

  const handleSubmitForm = (data: CompanyAddressesFormData) => {
    removeEmptyStrings(data);
    setEnrollmentData((prevState: EnrollmentData) => {
      return {
        ...prevState,
        companyAddressesFormData: data,
      };
    });
    nextPage();
  };
  useEffect(() => {
    ReactGA.send({
      hitType: 'pageview',
      pageTitle: 'E-Verify - Company Addresses',
    });
  }, []);
  return (
    <section className="padding-y-4">
      <h1 className="margin-bottom-4">Company Addresses</h1>
      <CompanyAddressesForm
        variantType={FormVariant.ENROLLMENT}
        onSubmitForm={handleSubmitForm}
        companyAddressesData={enrollmentData.companyAddressesFormData}
      />
    </section>
  );
};

export default CompanyAddresses;
